import { AbstractControl, UntypedFormControl, ValidatorFn } from '@angular/forms';

export function cardholderName(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' && !control.value
    .match(/^[A-Za-z \-]+$/)) {
    return { 'invalidName': true };
  }
  return null;
}

export function phone(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' && !control.value
    .match(/^\d{10,15}$/)) {
    return { 'invalidPhone': true };
  }
  return null;
}

export function email(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' && !control.value
    .match(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
    return { 'invalidEmail': true };
  }
  return null;
}

export function socSecurity(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' && !control.value
    .match(/^\d{9}$/)) {
    return { 'invalidSoc': true };
  }
  return null;
}

export function meu(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' && !control.value
    .match(/^\d{2}$/)) {
    return { 'invalidMeu': true };
  }
  return null;
}

export function lowerCase(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' && !control.value.match(/[a-z]/)) {
    return { 'lowerCaseError': true };
  }
  return null;
}

export function upperCase(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' && !control.value.match(/[A-Z]/)) {
    return { 'upperCaseError': true };
  }
  return null;
}

export function number(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' && !control.value.match(/[0-9]/)) {
    return { 'numberError': true };
  }
  return null;
}

export function specialCharacter(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' &&
    !control.value.match(/[!@#$%^&*()_\-+={}[\]|\\?\/<>,.:;~` ]/)) {
    return { 'specialCaseError': true };
  }
  return null;
}
export function minLength(control: UntypedFormControl): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' && control.value.length < 8) {
    return { 'lengthError': true };
  }
  return null;
}

export function passwordMatch(pass: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const password = pass;
    const confirmPassword = control.value;
    if (password !== confirmPassword) {
      return { 'matchError': true };
    }

    return null;

  };
}

export function accountMustMatch(email1: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    let acctNum = email1;
    let acctNum2 = control.value;
    if (acctNum !== acctNum2) {
      return { 'matchError': true };
    }

    return null;

  }
}






